import CobranzaCombobox from "./CobranzaCombobox";

export {CobranzaCombobox}
export default CobranzaCombobox


